import { createElement, PropTypes } from 'rlink-react';
import themeable from 'rlink-theme/themeable';

import StudioSection from 'components/AboutUs/StudioSection';
import TeamSection from 'components/AboutUs/TeamSection';
import CitySection from 'components/AboutUs/CitySection';

export default function AboutUsPanel({
  theme,
  studioSliderData,
  profileSliderData,
  cityGalleryImagesData,
  studioCopy,
}) {
  return (
    <section id="node-11" className="node node-single-page-section node-promoted view-mode-full" >
      <StudioSection
        studioCopy={studioCopy}
        studioSliderData={studioSliderData}
        {...StudioSection.theme({theme})} />
      <TeamSection
        profileSliderData={profileSliderData}
        {...TeamSection.theme({theme})} />
      <CitySection cityGalleryImagesData={cityGalleryImagesData} />
    </section >
  );
}

AboutUsPanel.propTypes = {
  studioCopy: PropTypes.string,
  studioSliderData: PropTypes.arrayOf(PropTypes.object),
  profileSliderData: PropTypes.arrayOf(PropTypes.object),
  cityGalleryImagesData: PropTypes.arrayOf(PropTypes.object),
};

themeable(AboutUsPanel, {
  forwards: [
    StudioSection,
    TeamSection,
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/AboutUs/AboutUsPanel.jsx